/**
 * "Review this seat's knock-on" (#1964, slice 3D of #1947).
 *
 * The ladder previews a seat whose person sits on another ward that session
 * (`POST …/shortfalls/seat/preview`) and hands the draft here; the app shell
 * mounts `<SeatKnockOnHost/>` once, which opens the shared review screen in
 * the right-panel overlay. The ladder closes as it opens (one drawer slot),
 * so the request carries everything the apply needs.
 */
import { create } from "zustand";

import type { SeatPreviewResponse, SeatTarget } from "../api/useSeatKnockOn";

export interface SeatKnockOnRequest {
  cycleId: string;
  target: SeatTarget;
  /** The person the lead picked. */
  displayName: string;
  preview: SeatPreviewResponse;
}

interface SeatKnockOnState {
  request: SeatKnockOnRequest | null;
  openSeatKnockOn: (r: SeatKnockOnRequest) => void;
  closeSeatKnockOn: () => void;
}

export const useSeatKnockOnStore = create<SeatKnockOnState>((set) => ({
  request: null,
  openSeatKnockOn: (r) => set({ request: r }),
  closeSeatKnockOn: () => set({ request: null }),
}));
